/* Waxit: drag or click the progress line under a rail to scroll it (26 Oct 2026). Same behaviour as the home page rows.
   Loaded by snippets/wx-head.liquid on the rebuilt page templates only (About, Contact, Support topic, Trade, Trade Overview, Marketing). */
(function () {
  if (window.wxProgDrag2) return; window.wxProgDrag2 = 1;
  var SEL = '.to-prog, .mk-prog, .wxa-prog, .wxt-prog';
  var TRACK = '[data-to-track], [data-mk-track], [data-wxa-rail], [data-track]';
  var css = document.createElement('style');
  css.textContent = '.to-prog, .mk-prog, .wxa-prog, .wxt-prog { cursor: grab; touch-action: none; box-sizing: content-box !important; border-top: 10px solid transparent !important; border-bottom: 10px solid transparent !important; background-clip: padding-box !important; } .to-prog.is-drag, .mk-prog.is-drag, .wxa-prog.is-drag, .wxt-prog.is-drag { cursor: grabbing; }';
  document.head.appendChild(css);
  document.addEventListener('pointerdown', function (e) {
    var prog = e.target.closest && e.target.closest(SEL);
    if (!prog || prog.hasAttribute('data-wxt-prog') || prog.classList.contains('is-off') || e.button > 0) return;
    var box = prog.parentElement, tr = null;
    while (box && !(tr = box.querySelector(TRACK))) box = box.parentElement;
    if (!tr || tr.scrollWidth <= tr.clientWidth + 2) return;
    e.preventDefault();
    var bar = prog.firstElementChild, pr = prog.getBoundingClientRect(), ratio = tr.scrollWidth / pr.width;
    var snap = tr.style.scrollSnapType, beh = tr.style.scrollBehavior;
    tr.style.scrollSnapType = 'none'; tr.style.scrollBehavior = 'auto';
    if (bar) {
      var br = bar.getBoundingClientRect();
      if (e.clientX < br.left || e.clientX > br.right) tr.scrollLeft = (e.clientX - pr.left - br.width / 2) * ratio;
    }
    var x0 = e.clientX, s0 = tr.scrollLeft;
    prog.classList.add('is-drag'); try { prog.setPointerCapture(e.pointerId); } catch (err) {}
    function move(ev) { tr.scrollLeft = s0 + (ev.clientX - x0) * ratio; }
    function up() {
      prog.classList.remove('is-drag');
      prog.removeEventListener('pointermove', move); prog.removeEventListener('pointerup', up); prog.removeEventListener('pointercancel', up);
      tr.style.scrollBehavior = beh; tr.style.scrollSnapType = snap;
    }
    prog.addEventListener('pointermove', move); prog.addEventListener('pointerup', up); prog.addEventListener('pointercancel', up);
  });
})();
